/* import __COLOCATED_TEMPLATE__ from './market-date-time-select.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
let MarketDateTimeSelect = (_class = class MarketDateTimeSelect extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "localeTime", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "i18n", _descriptor3, this);
  }
  get startDate() {
    return this.args.startDate;
  }
  get endDate() {
    return this.args.endDate;
  }
  get isAllDay() {
    return this.args.isAllDay;
  }
  get displayValue() {
    return this.generateDisplayDateTime();
  }
  get displayedDate() {
    return this.startDateString || new Date().toISOString();
  }
  get startDateString() {
    return this.startDate ? this.startDate.toISOString() : null;
  }
  get endDateString() {
    return this.endDate ? this.endDate.toISOString() : null;
  }
  isSameDate(startDate, endDate) {
    return startDate.getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear();
  }
  generateDisplayDateTime() {
    if (!this.startDate) {
      // Not valid
      return '';
    }
    if (!this.endDate) {
      if (this.isAllDay) {
        return this.localeTime.dateTime(this.startDate, 'dateYearLast');
      } else {
        return this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.startDate, 'dateYearLast'),
          time: this.localeTime.dateTime(this.startDate, 'shortTime')
        });
      }
    }
    if (this.isAllDay) {
      if (this.isSameDate(this.startDate, this.endDate)) {
        // Same date, no times
        return this.localeTime.dateTime(this.startDate, 'dateYearLast');
      } else {
        // Different dates, no times
        return `${this.localeTime.dateTime(this.startDate, 'dateYearLast')} - ${this.localeTime.dateTime(this.endDate, 'dateYearLast')}`;
      }
    } else {
      if (this.isSameDate(this.startDate, this.endDate)) {
        // Same date, different times
        const timeRange = `${this.localeTime.dateTime(this.startDate, 'shortTime')} - ${this.localeTime.dateTime(this.endDate, 'shortTime')}`;
        return this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.startDate, 'dateYearLast'),
          time: timeRange
        });
      } else {
        // Different dates, different times
        return `${this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.startDate, 'dateYearLast'),
          time: this.localeTime.dateTime(this.startDate, 'shortTime')
        })} - ${this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.endDate, 'dateYearLast'),
          time: this.localeTime.dateTime(this.endDate, 'shortTime')
        })}`;
      }
    }
  }
  setTimeToNoonIfNewDate(date, prevDate) {
    if (date && !prevDate) {
      date.setHours(12);
      date.setMinutes(0);
    }
  }
  dateChanged(isAllDay, startDate, endDate) {
    this.args.onChange(isAllDay, startDate, endDate);
  }
  allDayCheckboxValueChange(checked) {
    this.dateChanged(checked, this.startDate, this.endDate);
  }
  marketDateRangeChanged(event) {
    const startDateString = event.detail.startDate;
    const endDateString = event.detail.endDate;

    // Set default start and end times to noon instead of the current time
    const startDate = startDateString ? new Date(startDateString) : undefined;
    this.setTimeToNoonIfNewDate(startDate, event.detail.prevStartDate);
    const endDate = endDateString ? new Date(endDateString) : undefined;
    this.setTimeToNoonIfNewDate(endDate, event.detail.prevEndDate);
    this.dateChanged(this.isAllDay, startDate, endDate);
  }
  clearDates() {
    this.dateChanged(false);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "allDayCheckboxValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "allDayCheckboxValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "marketDateRangeChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "marketDateRangeChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearDates", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearDates"), _class.prototype), _class);
export { MarketDateTimeSelect as default };